/* RESPONSIBLE TEAM: team-ml */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-actions-hash */
/* eslint-disable ember/no-controller-access-in-routes */
/* eslint-disable ember/no-classic-classes */
import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';

export default Route.extend({
  intercomEventService: service(),
  analytics: {
    place: 'import',
  },

  activate() {
    this.controllerFor('apps/app/import/zendesk-chat').set('currentStep', 3);
  },

  beforeModel(transition) {
    // Redirects if user visits the url directly
    if (transition.urlMethod === null) {
      this.transitionTo('apps.app.import.zendesk-chat');
    }
  },
  actions: {
    didTransition() {
      this.intercomEventService.trackAnalyticsEvent({
        action: 'viewed',
        object: 'confirmation_page',
        context: 'zendesk_chat_import',
        conversation_import_id: this.controller.get('model.id'),
      });
    },
  },
});
